import axios from "axios";

const api = axios.create({
  baseURL: "https://api.datasales.info",
});

const handleBeforeRequest = (config: any) => {
  config.metadata = { startTime: new Date() };
  return config;
};

api.interceptors.request.use(handleBeforeRequest);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log({ error_response: error });

    error.config.metadata.endTime = new Date();
    error.duration =
      error.config.metadata.endTime - error.config.metadata.startTime;

    const dataError = {
      time: error.duration / 1000 + "s",
      baseURL: error.config.baseURL,
      url: error.config.url,
      method: error.config.method,
    };

    axios({
      // responseType: 'json',
      method: "POST",
      url: "https://api.datasales.info/editor-dev/log",
      data: {
        message: JSON.stringify(
          { title: "DS.Marketing (3.0)", ...dataError },
          null,
          "\t"
        ),
      },
      headers: {
        Authorization: `${localStorage.getItem("@datasales:token")}`,
      },
    });

    return Promise.reject(error);
  }
);

export default api;
